'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import ComponentWithPartials from 'UIComponents/mixins/ComponentWithPartials';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import React from 'react';
import I18n from 'I18n';
import UISelect from 'UIComponents/input/UISelect';
import InitialFilterParams from '../constants/InitialFilterParams';
import GoodFiltersAndPage from '../constants/GoodFiltersAndPage';
import Limits from '../constants/Limits';
var LOWER_LIMIT = InitialFilterParams.get(GoodFiltersAndPage.LIMIT);

var getLimits = function getLimits() {
  return [{
    text: I18n.text('sortingBar.pageLimit.showNumber', {
      numberOfItems: Limits.SMALL
    }),
    value: Limits.SMALL
  }, {
    text: I18n.text('sortingBar.pageLimit.showNumber', {
      numberOfItems: Limits.LARGE
    }),
    value: Limits.LARGE
  }];
};

var PageLimitPicker = createReactClass({
  displayName: "PageLimitPicker",
  mixins: [ComponentWithPartials],
  propTypes: {
    className: PropTypes.string,
    limit: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    total: PropTypes.number.isRequired
  },
  updateLimit: function updateLimit(_ref) {
    var value = _ref.target.value;
    this.props.onChange(_defineProperty({}, GoodFiltersAndPage.LIMIT, value));
  },
  render: function render() {
    var _this$props = this.props,
        className = _this$props.className,
        limit = _this$props.limit,
        total = _this$props.total;

    if (total <= LOWER_LIMIT) {
      return null;
    }

    return React.createElement(UISelect, {
      className: className,
      buttonUse: "transparent",
      value: limit,
      searchable: false,
      options: getLimits(),
      onChange: this.updateLimit
    });
  }
});
export default PageLimitPicker;